import { render, staticRenderFns } from "./TheAboutList.vue?vue&type=template&id=7e1a055a&scoped=true&"
import script from "./TheAboutList.vue?vue&type=script&lang=ts&"
export * from "./TheAboutList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1a055a",
  null
  
)

export default component.exports